import axios from "axios";
import { refreshTokenApi } from "./authApi";

const Api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "",
});

Api.interceptors.request.use(function (response) {
  const token = localStorage.getItem("token");
  if (token !== undefined && token !== null) {
    response.headers["authorization"] = `Bearer ${token}`;
  }
  return response;
});

Api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.log("inside - axios response interceptors with 401 status code");
      const refreshToken = localStorage.getItem("refreshToken");
      console.log("refreshToken", refreshToken);
      if (refreshToken) {
        refreshTokenApi({refresh_token:refreshToken})
          .then((res) => {
            console.log("res", res);
            localStorage.setItem("token", res.data.data.access_token);
            error.config.headers["token"] = res.data.access_token;
            return Api.request(error.config);
          })
            .catch((err) => {
              localStorage.clear();
      window.location =
        window.location.protocol + "//" + window.location.host + "/";
            });
      }
      else {
        localStorage.clear();
        window.location =
          window.location.protocol + "//" + window.location.host + "/";
      }
    }
    return Promise.reject(error);
  }
);

export default Api;
